import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConsoleOrderDrawer from "./ConsoleOrderDrawer";

/* Full order detail page , wraps the order panel with its own route so any
   order row anywhere can deep-link to /admin/order/{id}. The linked-messages
   card lives inside the drawer itself. */
export default function ConsoleOrderDetail() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  return (
    <div data-testid="console-order-detail">
      <ConsoleOrderDrawer
        orderId={orderId}
        onClose={() => navigate(-1)}
        onUpdated={() => {}}
      />
    </div>
  );
}
